// extracted by mini-css-extract-plugin
export default {"load":"Loading_load__CGOuK"};